import React, { useEffect, useState } from 'react';
import { clearPaymentDetails, getPaymentDetails } from '../../redux/slices/user';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Button,
  Stack,
  Card,
  CardContent,
  Skeleton,
  Radio, IconButton,
  CircularProgress,
  DialogActions
} from "@mui/material";
import { Wallet, CreditCard, AddCard } from "@mui/icons-material";
import { CurrencySimple, useResponsiveValue } from "../../utils/helper";
import EditIcon from "@mui/icons-material/Edit";
import { motion, AnimatePresence } from "framer-motion";
import CtaButton from '../buttonWithArrow';
import {
  getWalletRecharge
} from '../../redux/slices/cards';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { usePathname } from 'next/navigation';
import WalletRecharge from '../walletRecharge';
import DoneIcon from '@mui/icons-material/Done';

// ---------- helpers ----------
const CURRENCY = {
  USD: { sign: "$", rate: 1, type: "string" },
  AED: { sign: "images/bannerImage/1758795455186.svg", rate: 3.67, type: "image" },
  // EUR: { sign: "€", rate: 0.92 },
};


const ErrorDialog = ({ status, open, onClose, message }) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby='error-dialog-title'
    aria-describedby='error-dialog-description'
  >
    <DialogContent
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center'
      }}
    >
      {
        status ? <DoneIcon style={{ color: 'green', fontSize: 40, marginBottom: 10 }} /> :
          <ErrorOutlineIcon
            style={{ color: 'red', fontSize: 40, marginBottom: 10 }}
          />
      }
      <Typography variant='body1'>{message}</Typography>
    </DialogContent>
    <DialogActions style={{ justifyContent: 'center' }}>
      <Button onClick={onClose} color='primary'>
        OK
      </Button>
    </DialogActions>
  </Dialog>
)

const getRandomGradient = (index) => {
  const gradients = [
    "linear-gradient(135deg, #4FA8A3 0%, #79C68A 100%)", // teal-green
    "linear-gradient(135deg, #F6D365 0%, #FDA085 100%)", // warm yellow-orange 
    "linear-gradient(135deg, #6FB1FC 0%, #4364F7 100%)", // blue   
    "linear-gradient(135deg, #46A1C9 0%, #6AD1C7 100%)", // aqua
    "linear-gradient(135deg, #5FB6AE 0%, #8AD09B 100%)", // mint        
    "linear-gradient(135deg, #A1C4FD 0%, #C2E9FB 100%)", // soft blue
    "linear-gradient(135deg, #89F7FE 0%, #66A6FF 100%)", // cyan-blue
    "linear-gradient(135deg, #43E97B 0%, #38F9D7 100%)", // green-turquoise    
  ];

  return gradients[index];
};


function Index({
  handleCardOption,
  price,
  bookingLoader,
  message,
  roomDetails, handleClose, errorMessage, setErrorMessage, paymentMode, setTransRef, setPaymentMode, paymentBottom
}) {

  const dispatch = useDispatch();
  const theme = useTheme();
  const { paymentDetails, error } = useSelector((state) => state.user);
  const {
    walletRecharge
  } = useSelector(state => state.cards)
  const pathname = usePathname()
  const [errorMsg, setErrorMsg] = useState(null);
  const [errorStatus, setErrorStatus] = useState(false);
  const [getCardList, setGetCardList] = useState([]);
  const [selectedValue, setSelectedValue] = useState('new');
  const [loading, setLoading] = useState(true);
  const [activeCard, setActiveCard] = useState(null);
  const [cards, setCards] = useState([]);
  const [minAmount, setMinAmount] = useState(true);
  const [maxAmount, setMaxAmount] = useState(true);
  const [loadingRecharge, setLoadingRecharge] = useState(false)
  const [getSelectedDetails, setSelectedDetails] = useState({
    type: 4
  });
  const [updateAmount, setUpdateAmount] = useState(false);
  const [openWalletAmountEnter, setOpenWalletAmountEnter] = useState(false)
  const [walletAmount, setWalletAmount] = useState(0)
  const userId = JSON.parse(sessionStorage.getItem('rslkey'));
  const [cardList, setCardList] = useState([]);
  const [cardReq, setCardReq] = useState({
    paymentOption: "4",// 4-new card, 3-saved card
    transRef: null
  });

  // 👇 Example function that runs every 10s when updateAmount is true
  const fetchUpdatedAmount = () => {
    const obj = {
      userId: userId,
      amount: price,
    };
    dispatch(getPaymentDetails(obj));
  };

  // 1️⃣ Run fetchUpdatedAmount every 10 seconds when updateAmount === true
  useEffect(() => {
    let intervalId;

    if (updateAmount) {
      // run immediately once (optional)
      // fetchUpdatedAmount();

      // then schedule every 10 seconds
      // intervalId = setInterval(fetchUpdatedAmount, 5000);
      intervalId = setInterval(null, 5000);
    }

    // cleanup when component unmounts or updateAmount becomes false
    return () => {
      if (updateAmount) {
        fetchUpdatedAmount();
      }
      clearInterval(intervalId);
    };
  }, [updateAmount]);

  // 2️⃣ Check localStorage and disable auto-update if key missing
  useEffect(() => {
    const checkLocalStorage = () => {
      const val = localStorage.getItem("updateAmount");
      if (!val) {
        setUpdateAmount(false);
        // fetchUpdatedAmount()
        // setLoading(true);
      }
    };

    // run check immediately
    checkLocalStorage();

    // optional: watch for storage changes from other tabs/windows
    window.addEventListener("storage", checkLocalStorage);

    // periodically check every 5 seconds (optional safety)
    const checkInterval = setInterval(checkLocalStorage, 5000);

    return () => {
      window.removeEventListener("storage", checkLocalStorage);
      clearInterval(checkInterval);
    };
  }, []);

  useEffect(() => {
    fetchUpdatedAmount()
    setLoading(true);
  }, [price]);

  useEffect(() => {

    if (paymentDetails) {
      setLoading(false);
      setGetCardList(paymentDetails);
      setCardList(paymentDetails?.responseData?.savedCardsList || []);
      const updatedCards = paymentDetails?.responseData?.savedCardsList?.map((card, inx) => ({
        ...card,
        background: getRandomGradient(inx), // 👈 add new field here
      }));

      setCards(updatedCards);

      if (paymentDetails?.responseData?.savedCardsList?.length > 0) {
        if (paymentDetails?.responseData?.savedCardsList?.filter((data) => data.default_card === 1)?.length > 0) {
          setActiveCard(paymentDetails?.responseData?.savedCardsList?.filter((data) => data.default_card === 1)?.[0]);
        } else {
          setActiveCard(paymentDetails?.responseData?.savedCardsList?.[0])
        }
      }

      var getCardDefault = null;
      if (paymentDetails?.responseData?.defaultPaymentOption === 1) {
        setSelectedDetails({
          type: 1,
          data: getCardDefault,
        });
        setSelectedValue('wallet');
        setPaymentMode("5");
        setTransRef(null);
      } else {
        if (paymentDetails?.responseData?.savedCardsList) {
          getCardDefault = paymentDetails?.responseData?.savedCardsList.filter(
            (data) => data.default_card
          );

          setSelectedDetails({
            type: 3,
            data: getCardDefault[0],
          });
          setSelectedValue(getCardDefault[0]?.passenger_cardid);
          setPaymentMode("5");
          setTransRef(getCardDefault[0]?.pre_transaction_id);
        } else {
          setPaymentMode("13");
          setTransRef(null);
        }
      }
      dispatch(clearPaymentDetails())
    }
  }, [paymentDetails]);

  useEffect(() => {
    if (getCardList) {
      if (getCardList?.responseData?.wallet.status === 0 || getCardList?.responseData?.wallet.status === 2) {
        setSelectedValue('new');
        setSelectedDetails({
          type: 4
        });
        setPaymentMode("13");
      }
    }
  }, [getCardList])

  const handleChange = (e, type, data) => {
    setTransRef(null);
    if (type === 4) {
      setSelectedValue(e.target.value);
      setSelectedDetails({
        type: type,
        data: '',
      });
      setPaymentMode("13");
    } else if (type === 3) {
      setSelectedValue(e.target.value);
      setActiveCard(data);
      setSelectedDetails({
        type: type,
        data: data,
      });
      setTransRef(data?.pre_transaction_id);
      setPaymentMode("2");
    } else if (type === 1) {
      setPaymentMode("5");
      setSelectedValue(e.target.value);
      setSelectedDetails({
        type: 1,
        data: data,
      });
    }
  };

  const handlePay = () => {
    if (getSelectedDetails !== undefined) {
      handleCardOption(getSelectedDetails);
    } else {
      alert('Please select payment method');
    }
  };

  const PaymentOption = ({
    label,
    icon,
    value,
    disabled, onClick, isActive, img
  }) => (
    <Card
      // onClick={() => !disabled && setSelectedMethod(value)}
      onClick={onClick}
      sx={{
        flex: 1,
        border: isActive ? "2px solid #009688" : "1px solid #ddd",
        borderRadius: 3,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        boxShadow: "none",
        transition: "all 0.2s ease-in-out",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 1,
          py: 2,
        }}
      >
        {/* {icon} */}
        <img
          src={img}
          alt={label}
          style={{
            width: 46,
            height: 46,
            filter: isActive ? "brightness(100%)" : "grayscale(100%)",
          }}
        />
        <Typography variant="body2" fontWeight={500}>
          {label}
        </Typography>
      </CardContent>
    </Card>
  );

  const responsiveFontSize = useResponsiveValue({ xs: 14, sm: 14, lg: 14 });

  // 🔄 When clicked, bring card to front
  const handleClick = (id) => {
    const clicked = cards.find((c) => c.passenger_cardid === id);
    if (!clicked) return;
    setCards([clicked, ...cards.filter((c) => c.passenger_cardid !== id)]);
  };

  const handlePopupWalletAmount = () => {
    setOpenWalletAmountEnter(true)
  }

  const handleCloseWalletAmount = () => {
    setWalletAmount(0)
    setOpenWalletAmountEnter(false)
    setMinAmount(true);
    setMaxAmount(true);
    setErrorStatus(false);
    setErrorMsg("");
    setLoadingRecharge(false);
  }

  const handleRechargeWallet = () => {
    // setLoading(true);    
    if (userId && !minAmount && !maxAmount) {
      setLoadingRecharge(true)
      let obj = { userId: userId, amount: walletAmount }
      if (cardReq.paymentOption === "3" && cardReq.transRef) {
        obj.paymentOption = cardReq.paymentOption;
        obj.transRef = cardReq.transRef;
      }
      dispatch(getWalletRecharge(obj))
    }
  }

  useEffect(() => {
    if (walletRecharge && walletRecharge?.status === 1 && loadingRecharge) {
      sessionStorage.setItem('isWalletRef', walletRecharge.ref)
      sessionStorage.setItem('isWalletRecharge', true)
      sessionStorage.setItem('walletMoney', walletAmount)
      localStorage.setItem('paymentRecharge', pathname);
      // setTimeout(() => {
      //   window.location.href = walletRecharge.orderUrl
      // }, 100)
      setLoadingRecharge(false);
      if (walletRecharge?.paymentOption === "3") {
        setErrorStatus(true);
        setErrorMsg(walletRecharge.message || '');
      } else {
        setTimeout(() => {
          handleCloseWalletAmount();
          setUpdateAmount(true);
          localStorage.setItem("updateAmount", "wallet");
          window.open(walletRecharge.orderUrl, "_blank");
        }, 100);
      }
    } else {
      setErrorStatus(false);
      setLoadingRecharge(false)
      setErrorMessage(walletRecharge.message || '')
    }
  }, [walletRecharge])

  // Handle key events (Backspace, Arrow Navigation)
  const handleKeyDown = (e) => {
    // Prevent entering non-numeric characters, including 'e', '+', and '-'
    if (['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <Box>

      {loading ? (
        <Skeleton
          sx={{
            margin: 'auto',
            color: 'blue',
          }}
        />
      ) : (
        <>
          <Typography variant="subtitle2" display="flex" justifyContent="start" mb={1} fontWeight={600}>
            Payment Method
          </Typography>

          <Stack
            direction="row"
            spacing={2}
            mb={2}
            sx={{
              width: {
                xs: "100%",   // ⬅ Mobile (small screen)
                sm: 360,      // ⬅ Small tablets
                md: 500,      // ⬅ Default desktop width
              },
              overflowX: "auto",        // allow scroll on small devices
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {userId && userId !== "" && (
              <PaymentOption
                label="Wallet"
                img="/img/payment/wallet.svg"
                value="wallet"
                onClick={() => handleChange({ target: { value: "wallet" } }, 1, "")}
                isActive={selectedValue === "wallet"}
              />
            )}

            {getCardList?.responseData?.savedCardsList?.length > 0 && (
              <PaymentOption
                label="Saved Card"
                img="/img/payment/saved.svg"
                value="saved"
                onClick={() =>
                  handleChange(
                    { target: { value: activeCard?.passenger_cardid } },
                    3,
                    activeCard
                  )
                }
                isActive={selectedValue === activeCard?.passenger_cardid}
              />
            )}

            <PaymentOption
              label="New Card"
              img="/img/payment/newcard.svg"
              value="new"
              onClick={() => handleChange({ target: { value: "new" } }, 4, "")}
              isActive={selectedValue === "new"}
            />
          </Stack>

          {
            paymentMode === "5" && (
              <Box textAlign="start">
                <Typography variant="body2" mb={1}>
                  Available Balance
                </Typography>
                <Stack direction="row" justifyContent="start" alignItems="center" gap={1}>
                  {/* <Typography variant="h6" fontWeight={600}>
                {CurrencySimple(getCardList?.responseData?.wallet?.walletAmount, "#000", responsiveFontSize, null, null)}
              </Typography> */}
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#f3f5f4", // light gray
                      borderRadius: "30px",
                      px: 2,
                      py: 0.5,
                      minWidth: "fit-content",
                    }}
                  >
                    <Typography
                      variant="h6"
                      fontWeight={600}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        color: "#000",
                        fontSize: responsiveFontSize
                      }}
                    >
                      {CurrencySimple(
                        getCardList?.responseData?.wallet?.walletAmount,
                        "#000",
                        responsiveFontSize,
                        null,
                        null
                      )}
                    </Typography>
                  </Box>

                  <Button
                    size="small"
                    variant="contained"
                    sx={{
                      textTransform: "none",
                      background: "#00ACC1",
                      borderRadius: "20px",
                      px: 2,
                      "&:hover": { background: "#0097A7" },
                    }}
                    onClick={handlePopupWalletAmount}
                  >
                    Recharge
                  </Button>
                </Stack>
                <Typography
                  variant="caption"
                  mt={1}
                  className={
                    getCardList?.responseData?.wallet.status === 0
                      ? 'text-danger'
                      : getCardList?.responseData?.wallet.status === 2
                        ? 'text-danger'
                        : 'text-success'
                  }
                >
                  {getCardList?.responseData?.wallet.message}
                </Typography>
              </Box>
            )
          }

          {
            paymentMode === "2" && getCardList?.status === 1 && getCardList?.responseData?.savedCardsList.length !== 0 &&
            <Box
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 8,
                alignItems: "center",
                justifyContent: "space-between",
                flexDirection: { xs: "column-reverse", md: "row" },
                p: 2,
              }}
            >
              {/* Left side - Input details */}
              <Box sx={{ flex: "1", display: "flex", flexDirection: "column", gap: 2, width: "100%" }}>
                <Box>
                  <Typography fontWeight={600} mb={0.5} display="flex" justifyContent="start">
                    Name on card
                  </Typography>
                  <Box
                    sx={{
                      background: "#f3f5f4",
                      borderRadius: "30px",
                      px: 2,
                      py: 1.5,
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    {getCardList?.responseData?.passengerName ?? getCardList?.responseData?.phone}
                  </Box>
                </Box>

                <Box>
                  <Typography fontWeight={600} mb={0.5} display="flex" justifyContent="start">
                    Card Details
                  </Typography>
                  <Box
                    sx={{
                      background: "#f3f5f4",
                      borderRadius: "30px",
                      px: 2,
                      py: 1.5,
                      display: "flex",
                      alignItems: "center",
                      fontWeight: 500,
                    }}
                  >
                    xxxxxxxxxxxx{activeCard?.masked_creditcard_no}
                  </Box>
                </Box>
              </Box>

              {/* Right side - Credit card preview */}
              {getCardList?.responseData?.savedCardsList?.length === 1 ?
                <Card
                  sx={{
                    flex: "1",
                    borderRadius: "16px",
                    background: "linear-gradient(135deg, #27b0b8, #007ea7)",
                    color: "#fff",
                    width: "300px",
                    height: "200px",
                    position: "relative",
                    boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                    overflow: "hidden",
                  }}
                >
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "100%",
                    }}
                  >
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mb: 2,
                        }}
                      >
                        <Box
                          component="img"
                          src="/img/chip.svg" // ← replace with your chip image path
                          alt="Card chip"
                          sx={{
                            width: 36,
                            height: 26,
                            borderRadius: "4px",
                            objectFit: "cover",
                          }}
                        />

                        <Typography variant="h6" fontWeight={700} color="rgba(255,255,255,0.8)">
                          {getCardList?.responseData?.savedCardsList?.[0]?.card_type}
                        </Typography>
                      </Box>
                      <Typography variant="h6" fontWeight={600} display="flex" justifyContent="start" color="rgba(255,255,255,0.8)" letterSpacing={3}>
                        **** **** **** {getCardList?.responseData?.savedCardsList?.[0]?.masked_creditcard_no}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-end",
                        mt: 2,
                      }}
                    >
                      <Box>
                        <Typography variant="caption" color="rgba(255,255,255,0.8)">
                          Card Holder name
                        </Typography>
                        <Typography fontWeight={500}>{getCardList?.responseData?.passengerName ?? getCardList?.responseData?.phone}</Typography>
                      </Box>
                      <Box>
                        <Typography variant="caption" color="rgba(255,255,255,0.8)">
                          Expiry Date
                        </Typography>
                        <Typography fontWeight={500}>02/30</Typography>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
                :
                <Box sx={{ position: "relative", width: "auto", height: "auto", mx: "auto" }}>
                  <Box
                    sx={{
                      position: "relative",
                      width: 288,
                      height: 200,
                      margin: "auto",
                      perspective: 1000,
                      background: "#000",
                      borderRadius: "16px 16px 30px 30px",
                    }}
                  >
                    {cards?.map((card, index) => (
                      <motion.div
                        key={card?.passenger_cardid}
                        layout
                        transition={{ type: "spring", stiffness: 300, damping: 25 }}
                        onClick={() => {
                          handleClick(card?.passenger_cardid);
                          handleChange({ target: { value: card?.passenger_cardid } }, 3, card);
                        }}
                        style={{
                          position: "absolute",
                          // top: index + 1 * ((cards?.length - index) * (index + 4 * 5)),
                          bottom: index === 0 ? 60 : 60 + (index * 25),
                          left: 0,
                          width: "100%",
                          height: 80,
                          cursor: "pointer",
                          zIndex: cards.length - index,
                          display: "flex",
                          justifyContent: "center"
                        }}
                      >
                        <Box
                          sx={{
                            width: "100%",
                            maxWidth: 260,
                            height: "100%",
                            borderRadius: "16px",
                            // background: "linear-gradient(135deg, #4FA8A3 0%, #79C68A 100%)",
                            background: card?.background,
                            color: "#fff",
                            boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            px: 2,
                            py: 1,
                            border: "1px solid #000",
                            transition: "transform 0.3s",
                            "&:hover": { transform: "scale(1.02)" },
                            display: "flex",
                            justifyContent: "space-between",
                            flexDirection: "row"
                          }}
                        >
                          <Box
                            component="img"
                            src="/img/chip.svg" // ← replace with your chip image path
                            alt="Card chip"
                            sx={{
                              width: 26,
                              height: 16,
                              borderRadius: "4px",
                              objectFit: "cover",
                            }}
                          />
                          <Typography variant="h6" sx={{ textAlign: "right", fontWeight: 500, fontSize: "14px" }}>
                            {card?.card_type}
                          </Typography>
                        </Box>
                      </motion.div>
                    ))}
                  </Box>
                  {/* Pocket / Holder */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: -10,
                      width: "100%",
                      height: 120,
                      backgroundImage: "url('/img/FrontPart.svg')",
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                      paddingBottom: 2,
                    }}
                  >
                    <Typography variant="h6" sx={{ color: "white", fontWeight: 600 }}>
                      {getCardList?.responseData?.passengerName}
                    </Typography>
                  </Box>
                </Box>
              }
            </Box>
          }

          <hr />

          <Stack direction="row" justifyContent="flex-end" spacing={1} mt={3} mb={paymentBottom}>
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{
                borderRadius: "999px",       // pill shape
                border: "2px solid #BDBDBD", // grey border
                color: "#9E9E9E",            // grey text
                textTransform: "none",       // keep text case
                fontWeight: 500,
                fontSize: "16px",
                px: 4,
                py: 1,
                backgroundColor: "transparent",
                "&:hover": {
                  borderColor: "#9E9E9E",
                  backgroundColor: "rgba(0,0,0,0.03)", // subtle hover effect
                },
              }}
            >
              Cancel
            </Button>
            <CtaButton label="Pay" onClick={() => handlePay()} loader={bookingLoader} endIconSrc="/img/header/VectorRight.svg" />
          </Stack>

          <Dialog
            open={openWalletAmountEnter}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
            disableBackdropClick
            disableEscapeKeyDown
            fullWidth={true}
            maxWidth='sm'
          >
            <DialogTitle id='alert-dialog-title'>Top Up</DialogTitle>
            <DialogContent>
              <input
                type='number'
                name='amount'
                value={walletAmount}
                inputMode="numeric" // Enables numeric keypad on mobile devices
                pattern="[0-9]*" // Suggests a numeric-only keyboard
                onChange={e => {
                  setMaxAmount(false);
                  let value = e.target.value;

                  // Remove non-numeric characters except dot
                  value = value.replace(/[^0-9.]/g, "");

                  // Prevent multiple dots
                  if (value.split(".").length > 2) {
                    return;
                  }

                  // Limit to two decimal places
                  if (value.includes(".")) {
                    const [integer, decimal] = value.split(".");
                    value = `${integer}.${decimal.slice(0, 2)}`;
                  }

                  // Convert to number for validation
                  const numericValue = parseFloat(value) || 0;

                  // Enforce limits (0 - 5000)
                  if (numericValue > 5000) {
                    setMaxAmount(true);
                    return; // Stop updating if value exceeds 5000
                  }

                  setMinAmount(numericValue < 12 ? true : false)
                  setMaxAmount(numericValue > 5000 ? true : false)
                  setWalletAmount(value)
                }}

                onKeyDown={(e) => handleKeyDown(e)}
                style={{
                  padding: "0px 10px"
                }}
                className='border-light text-dark-1 h-50 rounded-8'
              />
              <p
                style={{
                  color: minAmount || maxAmount ? "red" : "white",
                  fontSize: "12px",
                }}
              >
                {minAmount
                  ? "Minimum amount should be 12 AED"
                  : maxAmount
                    ? "Maximum amount should be 5000 AED"
                    : "Valid"}
              </p>

              {
                cardList?.length > 0 &&
                <WalletRecharge getCardList={cardList} cardReq={cardReq} setCardReq={setCardReq} />
              }

            </DialogContent>

            <DialogActions>
              {loadingRecharge ? (
                ''
              ) : (
                <Button
                  onClick={handleCloseWalletAmount}
                  variant='contained'
                  className='button-disagree'
                >
                  Cancel
                </Button>
              )}

              <Button
                variant='contained'
                autoFocus
                onClick={handleRechargeWallet}
                className='button-agree'
              >
                {loadingRecharge ? (
                  <CircularProgress size={24} sx={{ color: '#ffffff' }} />
                ) : (
                  'Recharge'
                )}
              </Button>
            </DialogActions>
            <ErrorDialog
              status={errorStatus}
              open={errorStatus ? !!errorMsg : !!errorMessage}
              onClose={() => {
                if (errorStatus) {
                  setCardReq({
                    paymentOption: "4",// 4-new card, 3-saved card
                    transRef: null
                  });
                  setLoading(true);
                  fetchUpdatedAmount();
                  setErrorMsg(null);
                  handleCloseWalletAmount();
                } else {
                  setErrorMessage('');
                  setErrorMsg(null);
                }
              }}
              message={errorStatus ? errorMsg : errorMessage}
            />
          </Dialog>

        </>
      )}
    </Box>
  );
}

export default Index;
